module.exports = __webpack_public_path__ + "static/media/logo-코멘토@3x.a8f95b80.png";